export const YOUTUBE_VIDEO_URL = "https://www.youtube.com/embed/mc5CYPax5nw";

export const DISPLAY_YEAR = "2026";
